import _ from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import style from "./LessonDetails.module.css";

export interface ListItemsNamesDI {
  [index: string]: string | Array<string>;
  field: string;
  type: string;
  step: string;
  external: string;
  organizational: string;
  partners: Array<string>;
}
export interface LessonDetailsProps {
  listItemsNames: ListItemsNamesDI;
}

const LessonDetails: React.FC<LessonDetailsProps> = (props) => {
  const { listItemsNames } = props;
  const { name, type, partners, step, external, organizational, field } =
    listItemsNames;
  const { t } = useTranslation();
  const LessonDetailsItems = [
    { title: t("Lesson-field"), content: field },
    { title: t("Lesson-project-type"), content: type },
    { title: t("Lesson-project-step"), content: step },
    { title: t("Lesson-external-factor-involved"), content: external },
    {
      title: t("Lesson-organizational-unit-involved"),
      content: organizational,
    },
    { title: t("Lesson-project-partners"), content: partners },
  ];

  return (
    <div id={t("lesson-view-info")} tabIndex={1} className={style.wrapper}>
      <h1 className={style.title}>{t("Lesson-view-header")}</h1>
      <div className={style.detailsItems}>
        {LessonDetailsItems.map((item) => {
          return (
            <div
              key={item.title}
              id={item.title}
              tabIndex={1}
              className={style.infoWrapper}
            >
              <span></span>
              <div className={style.info}>
                <p className={style.itemTitle}>{item.title}</p>
                {item.content && item.content.length ? (
                  <p className={style.itemContent}>
                    {typeof item.content === "string"
                      ? item.content
                      : item.content.toString()}
                  </p>
                ) : (
                  <p>{t("View-lesson-empty-item")}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LessonDetails;
